/**
 * Orchid 11 Med Spa brand palette.
 *
 * primary  -> brand olive/gold, used throughout headings on the legacy site
 * secondary -> warm rose, used as the spa's accent color
 */
const colors = {
  background: {
    default: "#fbf8f1",
  },

  text: {
    main: "#4a4a4a",
    focus: "#4a4a4a",
  },

  // Use an alpha-channel rgba value rather than the literal CSS keyword
  // "transparent" — MUI's Button/Chip/IconButton variant generation walks
  // every palette entry that looks like a color and runs alpha() math on
  // `.main`, which throws on the non-numeric "transparent" keyword.
  transparent: {
    main: "rgba(0, 0, 0, 0)",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#141414",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#676504",
    focus: "#54520a",
  },

  secondary: {
    main: "#c2185b",
    focus: "#a3134c",
  },

  info: {
    main: "#1a73e8",
    focus: "#1662c4",
  },

  success: {
    main: "#4caf50",
    focus: "#3e9142",
  },

  warning: {
    main: "#fb8c00",
    focus: "#e07c00",
  },

  error: {
    main: "#f44335",
    focus: "#ea0606",
  },

  light: {
    main: "#fbeee6",
    focus: "#f5dccb",
  },

  dark: {
    main: "#2b2417",
    focus: "#1f1a10",
  },

  grey: {
    100: "#f8f9fa",
    200: "#f0f2f5",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: "#6c757d",
    700: "#495057",
    800: "#343a40",
    900: "#212529",
  },

  gradients: {
    primary: {
      main: "#7d7a08",
      state: "#54520a",
    },
    secondary: {
      main: "#e0568a",
      state: "#a3134c",
    },
    info: {
      main: "#4f9cf2",
      state: "#1662c4",
    },
    success: {
      main: "#66bb6a",
      state: "#3e9142",
    },
    warning: {
      main: "#ffa726",
      state: "#e07c00",
    },
    error: {
      main: "#ff6659",
      state: "#ea0606",
    },
    light: {
      main: "#ffffff",
      state: "#fbeee6",
    },
    dark: {
      main: "#3f3520",
      state: "#1f1a10",
    },
  },

  socialMediaColors: {
    facebook: { main: "#3b5998", dark: "#344e86" },
    twitter: { main: "#55acee", dark: "#3ea1ec" },
    instagram: { main: "#125688", dark: "#0e456d" },
    google: { main: "#dd4b39", dark: "#c23321" },
  },

  badgeColors: {
    primary: { background: "#f8f4d6", text: "#676504" },
    secondary: { background: "#fbe1ec", text: "#c2185b" },
    info: { background: "#d9eaff", text: "#1a73e8" },
    success: { background: "#e1f4e1", text: "#4caf50" },
    warning: { background: "#fff1dc", text: "#fb8c00" },
    error: { background: "#fde0dd", text: "#f44335" },
    light: { background: "#ffffff", text: "#6c757d" },
    dark: { background: "#dee2e6", text: "#2b2417" },
  },

  inputBorderColor: "#d2d6da",

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },
};

export default colors;
